
<mat-form-field>
	<ogs-m3-icon prefix="fal" icon="globe" matPrefix/>
	<mat-select panelClass="select__panel--surface"  [value]="currentLocale()" (selectionChange)="onLocaleSelectionChange($event)" [compareWith]="_languageSelectionService.compareLocales">
			@for (locale of _languageSelectionService.locales; track $index) {
					<mat-option [value]="locale">{{locale.localizedName.defaultText | translate : locale.localizedName.token : locale.localizedName.scope}}</mat-option>
			}
	</mat-select>
</mat-form-field>